import "./AppointmentOverlay.scss";
import * as Sentry from "@sentry/react";
import { ReactNode } from "react";
import { useDispatch } from "react-redux";
import { finishAppointment } from "../../store/slices/appointmentOverlaySlice";

// If the overlay crashes, this stands in for it so the clinician can still close it.
const CrashFallback = ({ resetError }: { resetError: () => void }) => {
  const dispatch = useDispatch();
  return (
    <section className="appointment-overlay-crash" role="alert">
      <p className="appointment-overlay-crash__text">
        The appointment panel ran into a problem. Closing it leaves the appointment in
        progress; finish it from its details page.
      </p>
      <button
        type="button"
        className="appointment-overlay-crash__close"
        onClick={() => {
          dispatch(finishAppointment());
          resetError();
        }}
      >
        Close panel
      </button>
    </section>
  );
};

const AppointmentOverlayBoundary = ({ children }: { children: ReactNode }) => (
  <Sentry.ErrorBoundary fallback={({ resetError }) => <CrashFallback resetError={resetError} />}>
    {children}
  </Sentry.ErrorBoundary>
);

export default AppointmentOverlayBoundary;
